module.exports = __webpack_public_path__ + "img/eye-blue-open.c39df03e.svg";